function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgR = function SvgR(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 86"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M69.5 85.8H42.2L27.7 61.6l-1.7.2-1 24-23-.2L.9 1.3Q10.3.5 18.6.5 70 .5 70 30.7q0 1.8-.3 3.6-.3 1.7-.9 3.4-.5 1.7-1.3 3.3t-1.8 3.1q-4.3 6.5-14.4 11.5zM5.4 57.3 9.1 4.1H4.6zm21.3-14q8.1-1.2 12.7-4.3 4.6-3 4.6-7.4 0-5.2-3.5-7.9Q37 21.1 27.7 21zm6.2.7q13.4-2.4 13.4-9.3v-.8q-.1-.3-.1-.7-.1-.3-.2-.7-.1-.3-.2-.7-.5 8.8-12.9 12.2",
    style: {
      fill: "#bd338a"
    }
  }));
};
export default SvgR;